import "./TravelAndStay.module.css";
import Header from "@/reusable_sections/Header";
import RomanSojourn from "./sections/RomanSojourn";
import LocalTransportation from "./sections/LocalTransportation";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function TravelAndStayPage() {
  return <div>
      <Header />
      <RomanSojourn />
      <LocalTransportation />
      <Testimonials />
      <Footer />
    </div>;
}